import Achievement from "./Achievement";
import common from "./common";

export default class AchievementSystem
{
    constructor()
    {
        this._achievements = {};

        this.signals =
        {
            unlocked: new P3.utils.MiniSignal()
        };
    }

    destroy()
    {
        P3.utils.destroyAllSignals(this.signals);
    }

    parseData(data)
    {
        for (const i in data)
        {
            if (data.hasOwnProperty(i))
            {
                const temp = data[i];
                if (temp.enabled)
                {
                    const icon = P3.assets.texture(temp.icon);

                    this._achievements[temp.id] = new Achievement
                    (
                        temp.id,
                        temp.group,
                        temp.name,
                        icon
                    );
                }
            }
        }
    }

    setProgress(id, progress, overwrite = false, setting = AchievementSystem.SETTING_FORCE)
    {
        const user = common.save.getUserData(common.userId);
        if (user.achievements)
        {
            const unlocked = user.achievements[id] >= 1;
            if (!unlocked)
            {
                if (overwrite || (!user.achievements[id] || progress > user.achievements[id]))
                {
                    user.achievements[id] = P3.math.clamp(progress, 0, 1);
                }

                common.save.saveGame();

                if (progress >= 1)
                {
                    return this.unlock(id, setting);
                }
            }
        }
        return false;
    }

    unlock(id, setting = AchievementSystem.SETTING_DEFAULT)
    {
        const achievement = this._achievements[id];

        if (achievement != null)
        {
            let result = false;

            const user = common.save.getUserData(common.userId);
            if (user.achievements)
            {
                if ((setting === AchievementSystem.SETTING_FORCE || setting === AchievementSystem.SETTING_FORCE_SILENT || setting === AchievementSystem.SETTING_FORCE_HIDDEN) ||
                    (!user.achievements[id] || (user.achievements[id] && user.achievements[id] < 1)))
                {
                    user.achievements[id] = 1;
                    common.save.saveGame();

                    result = true;
                }
            }

            if (result)
            {
                if (setting !== AchievementSystem.SETTING_HIDDEN && setting !== AchievementSystem.SETTING_FORCE_HIDDEN)
                {
                    this.signals.unlocked.dispatch(achievement);
                }

                if (setting !== AchievementSystem.SETTING_FORCE_SILENT)
                {
                    // tracking
                    common.gmi.sendStatsEvent("achievement", "earned", {
                        source: achievement.name.toLowerCase().replace(/ /g, "_")
                    });
                }

                console.log("Achievement Unlocked: " + id);
                return true;
            }
        }
        return false;
    }

    getProgress(id)
    {
        const user = common.save.getUserData(common.userId);
        if (user.achievements)
        {
            return user.achievements[id];
        }
        return 0;
    }

    isUnlocked(id)
    {
        const user = common.save.getUserData(common.userId);
        if (user.achievements)
        {
            return user.achievements[id] >= 1;
        }
        return false;
    }

    isActive(id)
    {
        const achievement = this._achievements[id];
        if (achievement != null)
        {
            if (!this.isUnlocked(id))
            {
                if (achievement.group > -1)
                {
                    let active = null;

                    for (const i in this._achievements)
                    {
                        if (this._achievements.hasOwnProperty(i))
                        {
                            const other = this._achievements[i];
                            if (other.group === achievement.group)
                            {
                                if (this.isUnlocked(other.id))
                                {
                                    continue;
                                }

                                if (active === null)
                                {
                                    active = other;
                                }

                                if (other === achievement)
                                {
                                    return active === achievement;
                                }
                            }
                        }
                    }
                }
            }
            return true;
        }
        return false;
    }

    get achievements()
    {
        return P3.utils.copyObject(this._achievements, false);
    }
}

AchievementSystem.SETTING_DEFAULT = "default";
AchievementSystem.SETTING_HIDDEN = "hidden";
AchievementSystem.SETTING_FORCE = "force";
AchievementSystem.SETTING_FORCE_SILENT = "force_silent";
AchievementSystem.SETTING_FORCE_HIDDEN = "force_hidden";